import { useEffect, useState } from "react";
import { Crown } from "lucide-react";
import { api } from "../lib/api";
import { makeName } from "./WinnersTicker";

const PREFIX = "fc_top_earners_";
const weekKey = () => {
  const d = new Date();
  const monday = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() - ((d.getUTCDay() + 6) % 7)));
  return `${PREFIX}${monday.toISOString().slice(0, 10)}`;
};

// Made-up entries are kept for the whole week so the list doesn't reshuffle on every visit.
const weeklyFill = () => {
  const key = weekKey();
  try {
    const saved = JSON.parse(localStorage.getItem(key));
    if (saved?.length) return saved;
  } catch { /* regenerate */ }
  let amt = 900 + Math.floor(Math.random() * 8) * 50;
  const list = Array.from({ length: 10 }, (_, i) => {
    amt = Math.max(40, amt - (i === 0 ? 0 : 20 + Math.floor(Math.random() * 12) * 10));
    return { name: makeName(), amount: amt };
  });
  Object.keys(localStorage).filter((k) => k.startsWith(PREFIX) || k.startsWith("fc_top_drafts_")).forEach((k) => localStorage.removeItem(k));
  localStorage.setItem(key, JSON.stringify(list));
  return list;
};

const RANK = ["text-[#F59E0B]", "text-slate-300", "text-[#D97706]"];

// "This week's biggest earners": real players' total winnings merged with made-up ones, top 10.
const TopEarners = () => {
  const [rows, setRows] = useState(() => weeklyFill());

  useEffect(() => {
    api.topEarners().then((real) => {
      const names = new Set(real.map((r) => r.name.toLowerCase()));
      const merged = [...real, ...weeklyFill().filter((f) => !names.has(f.name.toLowerCase()))];
      setRows(merged.sort((a, b) => b.amount - a.amount).slice(0, 10));
    }).catch(() => {});
  }, []);

  return (
    <section data-testid="top-earners" className="mt-10 fade-up">
      <div className="flex items-baseline justify-between">
        <h2 className="font-display font-extrabold uppercase text-xl tracking-wide">This week's biggest earners</h2>
        <span className="text-[11px] text-[#64748B]">Resets Monday</span>
      </div>
      <ol className="mt-3 rounded-xl border border-[#334155] bg-[#1E293B] divide-y divide-[#334155]">
        {rows.map((r, i) => (
          <li key={`${r.name}-${i}`} data-testid={`top-earner-row-${i}`} className="flex items-center gap-3 px-4 py-2.5">
            <span className={`w-5 font-display font-extrabold tabular ${RANK[i] || "text-[#64748B]"}`}>{i + 1}</span>
            {i === 0 && <Crown className="w-4 h-4 text-[#F59E0B] -ml-1" />}
            <span data-testid={`top-earner-name-${i}`} className="flex-1 truncate text-sm font-semibold text-white">{r.name}</span>
            <span data-testid={`top-earner-amount-${i}`} className="font-display font-bold text-[#10B981] tabular">£{r.amount.toLocaleString()}</span>
          </li>
        ))}
      </ol>
    </section>
  );
};

export default TopEarners;
